import { render, staticRenderFns } from "./BadgeLabel.vue?vue&type=template&id=160e0230&"
import script from "./BadgeLabel.ts?vue&type=script&lang=ts&"
export * from "./BadgeLabel.ts?vue&type=script&lang=ts&"
import style0 from "./BadgeLabel.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports